// API Configuration
export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_BASE_URL || 'https://api.devaswom.org',
  TIMEOUT: 10000,
  ENDPOINTS: {
    // System endpoints
    HEALTH: '/',
    DATABASE: '/db',
    
    // Auth endpoints
    LOGIN: '/users/login',
    VALIDATE_TOKEN: '/users/validate-token',
    
    // User endpoints
    USERS: '/users',
    USER_BY_ID: (userid: string) => `/users/userid/${userid}`,
    
    // Packlog endpoints
    PACKLOG: '/packlog',
    PACKLOG_BY_TRANS: (transno: string) => `/packlog/transno/${transno}`,
    PACKLOG_BY_STATUS: (status: string) => `/packlog/packstatus/${status}`,
    PACKLOG_BY_TBLID: (tblid: string) => `/packlog/tblid/${tblid}`,
    PACKLOG_BY_DATE: (startDate: string, endDate: string) => `/packlog/packdt?startdate=${startDate}&enddate=${endDate}`,
    
    // Valueset endpoints
    VALUESET: '/valueset',
    VALUESET_BY_PARAM: (param: string) => `/valueset/param/${param}`,
    VALUESET_BY_ID: (id: string) => `/valueset/${id}`,
    CREATE_VALUESET: '/valueset',
    UPDATE_VALUESET: (id: string) => `/valueset/${id}`,
    
    // Vanchi endpoints
    VANCHI: '/vanchi',
    CREATE_VANCHI: '/vanchi',
    VANCHI_BY_CODE: (vanchicd: string) => `/vanchi/vanchicd/${vanchicd}`,
    VANCHI_BY_NADA: (nadacd: string) => `/vanchi/nadacd/${nadacd}`,
    VANCHI_BY_TBLID: (tblid: string) => `/vanchi/tblid/${tblid}`,
  }
};

// API Helper functions
export const getApiUrl = (endpoint: string): string => {
  return `${API_CONFIG.BASE_URL}${endpoint}`;
};

export const getAuthHeaders = (token: string) => ({
  'Authorization': `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export const getDefaultHeaders = () => ({
  'Content-Type': 'application/json',
});
